import { initializeApp } from "firebase/app"; 
import { getAuth,GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGIND_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app) // This is used to get an instance of a firebase authentication to authenticate user about SignUp, Login and others
export const db = getFirestore(app); // this imports firestore which is a noSQL database in document where we can read, write and modify our data
export const provider = new GoogleAuthProvider();
export const storage = getStorage(app)
export default app;